import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TegelModule } from '@scania/tegel-angular-17';
import { DeskPopoverComponent } from '../../desk-popover/desk-popover.component';
import { ReservationListComponent } from '../../reservation-list/reservation-list.component';
import { BuildingAdminComponent } from '../../../admin/building-admin/building-admin.component';
import { P28LK_DESKS } from '../shared/constants/p28-lk.desks';
import { BuildingReservationsBase } from '../shared/reservation-base';

@Component({
  selector: 'app-p28-lk',
  imports: [ReservationListComponent, TegelModule, DeskPopoverComponent, BuildingAdminComponent, CommonModule],
  templateUrl: './p28-lk.component.html',
  styleUrl: './p28-lk.component.scss'
})
export class P28LKComponent extends BuildingReservationsBase {
  public readonly desks = P28LK_DESKS;
}